module.exports = "/assets/data/8fa2323bb27a3a6b5c94d95cb8a250a3-UB8.data.json";